// Dependencies
import {all, call, fork, put, takeEvery} from "@redux-saga/core/effects";
// Action Types
import {
    SETTINGS_DRIVER_AVATAR,
    SETTINGS_DRIVER_DELETE,
    SETTINGS_DRIVER_GET_URL_FILE,
    SETTINGS_DRIVER_LOAD_CSV,
    SETTINGS_DRIVER_SEARCH_TRANSACTIONS,
} from "Redux/actionTypes";

// Actions
import {
    getUrlFileCsvResponse,
    loadDriverCsvResponse,
    searchTransactionsResponse,
    uploadDriverAvatarResponse
} from "Redux/actions";
import {clientGET} from 'Core/data/RestApi';
import {uploadFile} from "Core/data/FileUpload";

// Helpers
import {clientMutation, clientQuery} from "Core/data/GraphQLApi";
import {endpoints} from "Core/defaultValues";
import {ExceptionManager} from "Core/logManager";


function* getUrlFileAttachment({ payload }) {
	try {
		const { id } = payload;
		let data = yield call(
			clientQuery,
			`query (
        $id: Int!
      ){
        downloadAttachmentUrl: downloadAttachmentUrl(
          id: $id
        )
      }`,
			{
				id
			},
			endpoints.GRAPHQL_GENERAL,
		);
		if (data && data.downloadAttachmentUrl && data.downloadAttachmentUrl) {
			yield put(getUrlFileCsvResponse(data.downloadAttachmentUrl));
		} else throw 'There are not url attachment';
	} catch (exc) {
		// ALWAYS RETURN ACTION
		ExceptionManager(
			exc,
			'modules/settings/views/driver/redux/sagas',
			'getUrlFileAttachment',
		);
		yield put(getUrlFileCsvResponse(null));
	}
}

function* searchDriverTransaction({ payload }) {
    try {
        const {
            transactionId,
            nextToken
        } = payload;

        const query = `
                query searchTransactions ($transactionId: String!, $nextToken: String) {
                    searchTransactions (transactionId: $transactionId, nextToken: $nextToken) {
                        items {
                            Id
                            TransactionId
                            Type
                            State
                            ErrorMessage
                            NewId
                            Data
                            CreatedBy
                            CreatedOn
                            ProcessedOn
                        }
                        nextToken
                    }
                }
          `;

        const response = yield call(
            clientQuery,
            query,
            {
                transactionId,
                nextToken
            },
            endpoints.GRAPHQL_GENERAL
        );

        if (!response && !response.searchTransactions) {
            throw "Error while getting Transactions";
        }
        let searchTransactions = response.searchTransactions;
        yield put(searchTransactionsResponse({ items:searchTransactions, error: false }));
    } catch (exc) {
        yield put(searchTransactionsResponse({ items: [], error: true }));
        ExceptionManager(
            exc,
            "modules/settings/views/driver/redux/sagas",
            "searchDriverTransaction"
        );
    }
}

function* createDriverAvatar({ payload }) {
    const { file,fileKeyDelete } = payload;

    try {

        if(fileKeyDelete){
            const mutation = `mutation deleteAttachment ($id: Int!) {deleteAttachment (id: $id)}`;
            const data = yield call(clientMutation, mutation, { id: fileKeyDelete }, endpoints.GRAPHQL_GENERAL_V2);
        }

        if(file){
            let extension = file?.name.split(".").pop();
            let presignedUrlResponse = yield call(
                clientQuery,
                `query(
                        $repositoryCode: String
                        $fileExtension: String
                    ) {
                        Data: getPresignedUrl(
                            repositoryCode: $repositoryCode,
                            fileExtension: $fileExtension
                        ) {
                            repositoryCode
                            fileKey
                            url
                        }
                    }`,
                {
                repositoryCode: endpoints.REPOSITORY_CODE,
                fileExtension: extension,
                },
                endpoints.GRAPHQL_GENERAL_V2
            );


            if (!presignedUrlResponse || !presignedUrlResponse.Data) {
                throw "There are a problem uploading the File";
            }

            yield uploadFile(presignedUrlResponse.Data.url, file);

            //Register file
            let registerAttachmentResult = yield call(
                clientMutation,
                `mutation ($repositoryCode: String!, $fileKey: String!, $originalName: String){
                    attachment: registerAttachment(repositoryCode: $repositoryCode, fileKey: $fileKey, originalName: $originalName){
                        id
                        repositoryId
                        repositoryType
                        repositoryCode
                        repositoryPath
                        fileKey
                        originalName
                    }
                }`,
                {
                    repositoryCode: presignedUrlResponse.Data.repositoryCode,
                    fileKey: presignedUrlResponse.Data.fileKey,
                    originalName: file?.name,
                },
                endpoints.GRAPHQL_GENERAL
            );

            if (registerAttachmentResult) {
                yield put(uploadDriverAvatarResponse(registerAttachmentResult.attachment));
            } else {
                throw "There are a problem register the File";
            }
        }else{
            yield put(uploadDriverAvatarResponse({id:null,fileKey:fileKeyDelete}));

        }

    } catch (exc) {
        yield put(
            uploadDriverAvatarResponse({ })
        );
        ExceptionManager(
            exc,
            "modules/settings/views/driver/redux/sagas",
            "createDriverAvatar",
            true
        );
    }
}

function* watchMethods() {
    yield takeEvery(SETTINGS_DRIVER_SEARCH_TRANSACTIONS, searchDriverTransaction);
    yield takeEvery(SETTINGS_DRIVER_GET_URL_FILE, getUrlFileAttachment);
    yield takeEvery(SETTINGS_DRIVER_AVATAR, createDriverAvatar);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}
